import { Flex, Image, TableProps } from "antd";
import { capitalize } from "lodash";
import avatar from "../../../../assets/images/avatar.svg";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetTopFiveVendorsQuery } from "../../../../features/Dashboard/dashboard.api";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../../utils/number";
import { addKeyInArray } from "../../../../utils/utils";

const STATUS_CONFIG = {
  active: "status status-success",
  review: "status status-yellow",
  archived: "status status-error",
  draft: "status status-slate",
};
const TopFiveVendor = ({
  filter,
}: {
  filter: { year: number; month: number };
}) => {
  const { data } = useGetTopFiveVendorsQuery({
    params: {},
  });

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(1, 5, index),
    },
    {
      title: "Vendor Name",
      render: (val) => (
        <Flex align="center" gap={10}>
          <Image
            height={36}
            width={36}
            preview={false}
            className="rounded-full"
            src={avatar}
          />
          <div>
            <span className="block text-sm text-theme-gray-24 font-medium">
              {val?.business_name}
            </span>
            <span className="block text-xs text-theme-gray-40">
              {val?.email}
            </span>
          </div>
        </Flex>
      ),
    },
    {
      title: "Job Completed",
      dataIndex: "payment_stats",
      render: (val) => addCommaInNumber(val?.total_paid_count),
    },
    {
      title: "Total Paid",
      dataIndex: "payment_stats",
      render: (val) => <>BDT {addCommaInNumber(val?.total_paid_amount)}</>,
    },
    {
      title: "Pending Amount",
      dataIndex: "payment_stats",
      render: (val) => <>BDT {addCommaInNumber(val?.pending_amount)}</>,
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (val) => {
        return (
          <span
            className={STATUS_CONFIG[String(val) as keyof typeof STATUS_CONFIG]}
          >
            {capitalize(val)}
          </span>
        );
      },
    },
  ];
  return (
    <CustomTable
      title={"Top 5 Vendors by Payment Volume"}
      loading={false}
      limit={5}
      page={1}
      columns={columns}
      hidePagination
      total={10}
      dataSource={addKeyInArray(data?.data.top_vendors || [])}
      hideDifferentRowColor
      hideRowSelect
      filterSection={<></>}
    />
  );
};

export default TopFiveVendor;
